<template>
  <v-card class="d-flex align-center justify-center" light outlined>
    <div>
      <v-card-title style="background-color: #d2d7e1" class="text-center">
        <v-list-item>
          <v-list-item-title>
            <h2>Validate Trade</h2>
            <p class="mb-0">It will be created as a verified trade</p>
          </v-list-item-title>
        </v-list-item>
      </v-card-title>
      <v-card-text class="px-7 pt-3 pb-0">
        <v-form v-model="valid">
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="3" xl="3">
                <v-autocomplete v-model="tradeUser" :items="this.$store.state.users" :return-object="false" :rules="userRule"
                                item-text="user.email" @change="userChanged"
                                item-value="user.id" label="User" outlined prepend-icon="fa-user"/>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="3" xl="3">
                <v-autocomplete v-model="tradeAsset" :items="userAssets" :return-object="false" :rules="assetRule"
                                item-text="ticker" :disabled="tradeUser === 0"
                                item-value="id" label="Asset" outlined prepend-icon="fa-euro-sign"/>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="3" xl="3">
                <v-autocomplete v-model="tradeBrokerAccount" :disabled="tradeUser === 0" :items="userBrokerAccounts" :return-object="false"
                                :rules="brokerAccountRule" item-value="id" label="Broker Account" outlined
                                prepend-icon="fa-university">
                  <template v-slot:selection="data">
                    {{ (data.item.broker.name !== 'All')? ((data.item.identifier !== '')? data.item.identifier : data.item.broker.name): 'All' }}
                    <v-icon v-if="data.item.verified" color="blue" class="ml-2" small>fa-check-circle</v-icon>
                  </template>
                  <template v-slot:item="data">
                    {{ (data.item.identifier !== '')? `${data.item.broker.name} · ${data.item.identifier}` :  data.item.broker.name }}
                    <v-icon v-if="data.item.verified" color="blue" class="ml-2" small>fa-check-circle</v-icon>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="3" xl="3">
                <v-select v-model="tradeSide" :items="['Buy', 'Sell']" label="Side" outlined
                          prepend-icon="fa-arrows-alt-v" :disabled="tradeUser === 0" />
              </v-col>
            </v-row>

            <v-divider class="mt-n5 mb-3"/>

            <v-row>
              <v-col cols="12" sm="12" md="12" lg="4" xl="4">
                <v-menu v-model="menuOpenDate" :clonombrese-on-content-click="false" offset-y
                        transition="scale-transition">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="openDateFormatted" v-on="on" label="Open Date"
                                  outlined
                                  persistent-hint prepend-icon="fa-calendar" readonly @blur="openDate = parseDate(openDateFormatted)"/>
                  </template>
                  <v-date-picker v-model="openDate" no-title @input="menuOpenDate = false"/>
                </v-menu>
                <v-menu v-model="menuCloseDate" :close-on-content-click="false" offset-y transition="scale-transition">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="closeDateFormatted" v-on="on"
                                  :rules="closeDateRule"
                                  label="Close Date" outlined persistent-hint prepend-icon="fa-calendar"
                                  readonly @blur="closeDate = parseDate(closeDateFormatted)"/>
                  </template>
                  <v-date-picker v-model="closeDate" no-title @input="menuCloseDate = false"/>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="4" xl="4">
                <v-menu ref="menu" v-model="menuOpenTime" :close-on-content-click="false" :nudge-right="40"
                        :return-value.sync="openTime"
                        max-width="290px" min-width="290px" offset-y transition="scale-transition">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="openTime" v-on="on" label="Open Time" outlined prepend-icon="fa-clock"
                                  readonly></v-text-field>
                  </template>
                  <v-time-picker v-if="menuOpenTime" v-model="openTime"
                                 @click:minute="$refs.menu.save(openTime)"></v-time-picker>
                </v-menu>
                <!--v-text-field :rules="timeRule" label="Close Time" outlined prepend-icon="fa-clock" v-model="closeTime"/!-->
                <v-menu ref="menu2" v-model="menuCloseTime" :close-on-content-click="false" :nudge-right="40"
                        :return-value.sync="closeTime"
                        max-width="290px" min-width="290px" offset-y transition="scale-transition">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="closeTime" v-on="on" label="Close Time" outlined prepend-icon="fa-clock"
                                  readonly></v-text-field>
                  </template>
                  <v-time-picker v-if="menuCloseTime" v-model="closeTime"
                                 @click:minute="$refs.menu2.save(closeTime)"></v-time-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="4" xl="4">
                <v-text-field v-model="tradeEntryPrice" :rules="priceRule" hint="Please add all the digits" label="Entry Price"
                              outlined prepend-icon="fa-chart-line" type="number"/>
                <v-text-field v-model="tradeClosePrice" :rules="priceRule" hint="Please add all the digits" label="Close Price"
                              outlined prepend-icon="fa-chart-line" type="number"/>
              </v-col>
            </v-row>

            <v-divider class="mt-n5 mb-3"/>

            <v-row>
              <v-col cols="6" sm="6" md="6" lg="4" xl="4">
                <v-text-field v-model="tradeGrossProfit" hint="The gross profit in USD" label="Gross Profit" outlined
                              prepend-icon="fa-coins" type="number"/>
              </v-col>
              <v-col cols="6" sm="6" md="6" lg="4" xl="4">
                <v-text-field v-model="tradeCommissions" :rules="commissionsRule" label="Trade Commissions" outlined
                              prepend-icon="fa-coins" type="number"/>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="4" xl="4">view n
                <div class="d-flex align-center justify-center mt-3">
                  <v-btn class="text-center" outlined @click="addTrade">Add Trade</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/helpDesk';
export default {
  name: "AddTrade",
  data() {
    return {
      openDate: new Date().toISOString().substr(0, 10),
      closeDate: new Date().toISOString().substr(0, 10),
      openDateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      closeDateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      menuOpenDate: false,
      menuCloseDate: false,
      menuOpenTime: false,
      menuCloseTime: false,
      openTime: null,
      closeTime: null,

      tradeUser: 0,
      tradeAsset: 0,
      tradeSide: '',
      tradeBrokerAccount: 0,
      tradeOpenTime: '',
      tradeCloseTime: '',
      tradeEntryPrice: 0,
      tradeClosePrice: 0,
      tradeStopLossPrice: 0,
      tradeGrossProfit: 0,
      tradeCommissions: 0,
      tradeStrategy: 0,
      tradeMood: '',

      // DATA
      userAssets: [],
      userBrokerAccounts: [],

      // RULES
      valid: false,
      closeDateRule: [
        // eslint-disable-next-line no-unused-vars
        d => this.closeDate >= this.openDate || 'Close date must be after the open date'
      ],
      timeRule: [
        t => !!t || 'Time is required',
        t => t.length <= 5 || 'Add a valid HH:MM time',
        t => /.+:.+/.test(t) || 'Add a valid HH:MM time',
      ],
      priceRule: [
        p => p > 0 || 'Price must be greater than 0',
      ],
      commissionsRule: [
        c => c >= 0 || 'Commissions must be equal or greater than 0',
      ],
      userRule: [
        u => !!u || 'User is required',
      ],
      assetRule: [
        a => !!a || 'Asset is required',
      ],
      brokerAccountRule: [
        b => !!b || 'Broker account is required',
      ],
      strategyRule: [
        s => !!s || 'Strategy is required',
      ],
      moodRule: [
        m => !!m || 'Mood is required',
      ],
    };
  },
  watch: {
    openDate() {
      this.openDateFormatted = this.formatDate(this.openDate);
    },
    closeDate() {
      this.closeDateFormatted = this.formatDate(this.closeDate);
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {

    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    userChanged() {
      if(this.tradeUser !== 0) {
        Repository.allBrokerAccountsOfUser(this.tradeUser).then((response) => {
          if(response.status < 400) {
            this.userBrokerAccounts = response.data;
          }
        });

        Repository.allAssetsOflUser(this.tradeUser).then((response) => {
          if(response.status < 400) {
            this.userAssets = response.data;
          }
        });
      }
    },
    addTrade() {
      if(this.valid) {
        let netProfit = ( this.tradeGrossProfit * 1 ) - Math.abs(this.tradeCommissions * 1 );
        let priceDistance = Math.abs(this.tradeEntryPrice - this.tradeClosePrice );
        let tradeStopLossPrice = (this.tradeSide === 'Buy')? this.tradeEntryPrice - priceDistance : this.tradeEntryPrice + priceDistance;
        let pipValue = (priceDistance > 0.0)? ( Math.abs(this.tradeGrossProfit * 1) / (priceDistance)).toFixed(2) : (0).toFixed(2);
        let openTimeArray = this.openTime.split(':');
        let closeTimeArray = this.closeTime.split(':');
        let openDateTime = new Date(this.openDate.substr(0, 4), this.openDate.substr(5, 2) - 1, this.openDate.substr(8, 2), openTimeArray[0], openTimeArray[1]);
        let closeDateTime = new Date(this.closeDate.substr(0, 4), this.closeDate.substr(5, 2) - 1, this.closeDate.substr(8, 2), closeTimeArray[0], closeTimeArray[1]);

        // Validates rules
        if(openDateTime > closeDateTime) {
          alert('Trade can\'t be added.\nClose time SHOULD be after the Open time.');
          return;
        }
        if(this.tradeSide.startsWith("B", 0) &&
            (((this.tradeClosePrice * 1) > (this.tradeEntryPrice * 1) && (this.tradeGrossProfit * 1 < 0)) ||
                ((this.tradeClosePrice * 1) < (this.tradeEntryPrice * 1) && (this.tradeGrossProfit * 1 > 0))) ){
          // eslint-disable-next-line no-useless-escape
          alert(`Trade can\'t be added.\nIn a Long(Buy) trade with close price ${(this.tradeClosePrice * 1 > this.tradeEntryPrice * 1)? 'higher' : 'lower' } than the entry price, the Gross Profit CANNOT be ${(this.tradeGrossProfit * 1 > 0)? 'positive' : 'negative' }.`);
          return;
        }
        if(this.tradeSide.startsWith("S", 0) &&
            (((this.tradeClosePrice * 1) > (this.tradeEntryPrice * 1) && (this.tradeGrossProfit * 1 > 0)) ||
                ((this.tradeClosePrice * 1) < (this.tradeEntryPrice * 1) && (this.tradeGrossProfit * 1 < 0))) ){
          // eslint-disable-next-line no-useless-escape
          alert(`Trade can\'t be added.\nIn a Short(Sell) trade with close price ${(this.tradeClosePrice * 1 > this.tradeEntryPrice * 1)? 'higher' : 'lower' } than the entry price, the Gross Profit CANNOT be ${(this.tradeGrossProfit * 1 > 0)? 'positive' : 'negative' }.`);
          return;
        }

        let trade = {
          side: this.tradeSide.toUpperCase(),
          mood: 'NONE',
          openTime: openDateTime,
          closeTime: closeDateTime,
          entryPrice: ( this.tradeEntryPrice * 1 ),
          closePrice: ( this.tradeClosePrice * 1 ),
          stopLossPrice: ( tradeStopLossPrice * 1 ),
          netProfit: netProfit,
          pipValue: ( pipValue * 1 ),
          commisions: ( this.tradeCommissions * 1 ),
          user: { id: this.tradeUser },
          asset: { id: this.tradeAsset },
          brokerAccount: { id: this.tradeBrokerAccount }
        };
        console.log(trade);
        Repository.createVerifiedTrade(trade).then((response) => {
          if(response.status < 400) {
            alert('Trade successfully added!');
            this.tradeUser = 0;
            this.tradeAsset = 0;
            this.tradeSide = '';
            this.tradeBrokerAccount = 0;
          }else
            alert('Something went wrong :(');
        });
      }
      else
        alert('Trade can\'t be added.\nThere are one or more mandatory fields that are not filled.');
    },
    closeOverlay() {
      this.$emit('closeWindow');
    }
  },
}
</script>

<style scoped>

</style>
